import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import EmptyData from '../../../components/ui/EmptyData';
import { useSectorsByAdmin } from '../../../hooks/admin/sectors.admin';
import SectorListTable from '../../../components/admin/sectors/SectorListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewSectorsPage() {
    const {t} = useTranslation();
    
  const {data:sectors,isLoading,isError} = useSectorsByAdmin();
  return (
    <Layout title={t('admin_sidebar.sectors')} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateSector]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_sector"
              buttonLinkPath={`/admin/add-sector`}
              />
            </PermissionGate>
         </div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
        sectors && (
          sectors.length === 0 ?<EmptyData/> : <SectorListTable sectors={sectors}/>
        )
        }
    </Layout>
  )
}

export default AdminViewSectorsPage   